var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"notfound-message"},[_vm._v(" お探しのページは見つかりません ")]),_c('div',{staticStyle:{"text-align":"center"}},[_c('button',{staticClass:"notfound-button",on:{"click":_vm.backTopPage}},[_vm._v("トップページに戻る")])])])}
var staticRenderFns = []

export { render, staticRenderFns }